module.exports = __webpack_public_path__ + "dd7f75a07d288d3214dcae3b3fdad542.svg";